import React, { createContext, useReducer, useContext} from 'react';

export const DriverContext = createContext(null);
export const DriverContextDispatch = createContext(null);

export function DriverProvider({children}){
    const [active, dispatch] = useReducer(driver, {isActive: false, advanced: false, controlNet: false});
    return(
        <DriverContext.Provider value={active}>
            <DriverContextDispatch.Provider value={dispatch}>
                {children}
            </DriverContextDispatch.Provider>  
        </DriverContext.Provider>
    )

}

function driver(active, action){
    switch (action.type) {
        case 'reset':
            return {...active, isActive : false, advanced : false, controlNet : false}
        case 'on':
            return {...active, isActive : true};
        case 'off':
            return {...active, isActive : false};
        case 'advanced':
            return {...active, advanced : true, controlNet : false}    
        case 'controlNet':
            return {...active, advanced : false, controlNet : true}    
        case 'playground':
            return {...active, advanced : false, controlNet : true, isActive: true}
        default:
            return {active}
    }
}

export function useDriverContext() {
    return useContext(DriverContext);
}

export function useDriverContextDispatch() {
    return useContext(DriverContextDispatch);
}